import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TokenValidationResult } from "@shared-kernel/application/ports/public/public-repository";

export const verifyTokenValidity = createAsyncThunk<
  TokenValidationResult,
  { userId: string; token: string },
  { extra: Partial<Dependencies> }
>("users/verifyTokenValidity", async ({ userId, token }: { userId: string; token: string }, { extra: { publicRepository } }) => {
  return publicRepository!.verifyTokenValidity(userId, token);
});
